import React, { useContext, useState, useRef, useEffect } from "react";
import { AudioContext } from "../../services/AudioContext";
import { RadioContext } from "../../services/RadioProvider";
import useSyncedTrack from "../../services/useSyncedTrack";
import "./LRadioPlayerCoverFrame.css";

export default function LRadioPlayerCoverFrame() {
    const coverRef = useRef(null);
    const { nowPlaying } = useContext(RadioContext);
    const audioContext = useContext(AudioContext);
    const [initialTrack, setInitialTrack] = useState(null);

    const coverEffects = ["l-fade", "l-slide", "l-zoom"];
    const getRandomEffect = () => coverEffects[Math.floor(Math.random() * coverEffects.length)];

    const audioTimeMs = audioContext?.audioTimeMs ?? 0;
    const playbackState = audioContext?.playbackState;
    const syncedTrack = useSyncedTrack(nowPlaying, audioTimeMs, playbackState);

    useEffect(() => {
        const firstTrack = nowPlaying?.history?.[0];
        if (firstTrack) {
            setInitialTrack(firstTrack);
        }
    }, [nowPlaying]);

    const currentTrack = syncedTrack || initialTrack;

    useEffect(() => {
        if (coverRef.current && currentTrack?.coverUrl) {
            coverRef.current.className = "d-cover " + getRandomEffect();
        }
    }, [currentTrack?.coverUrl]);

    const artist = currentTrack?.artist || "";
    const songTitle = currentTrack?.title || "";
    const coverUrl = currentTrack?.coverUrl || "";
    const modifiedCoverUrl = coverUrl;

    return (
        <div className="l-outer-frame">
            <div className="l-cover-frame">
                <div id="l-frame" style={{ backgroundImage: `url(${coverUrl})` }} ></div>
                <div className="l-img">
                    {coverUrl && <img ref={coverRef} className="l-cover l-fade" src={modifiedCoverUrl} alt="Cover" />}
                </div>
                <div className="l-title">
                    <div className="l-title-info">
                        LIVE PLAYING TRACK
                    </div>
                    <div className="l-underline"></div>
                    <div className="l-title-artist">
                        {artist}
                    </div>
                    <div className="l-title-title">
                        {songTitle}
                    </div>
                    <div className="l-underline"></div>
                </div>
            </div>
        </div>

    );
}